export default "/images/error_server.svg?b15fd09237551a80c13e312d90d792ad";